import { getName } from 'country-list';
import { SentifyEntity } from 'modules/ESGSentiment/types/esgSentiment';

export const esgSentimentToTableParser = (data: SentifyEntity[]) =>
  data.map(
    ({
      countryCode,
      sentifiId,
      name,
      industryName,
      scopeId,
      scores,
      meta: { hasPermission, hasCompany, hasScore },
    }) => {
      const meta = [hasPermission, hasCompany, hasScore];

      return [
        scopeId,
        [name],
        getName(countryCode) || '-',
        industryName || '-',
        [scores?.eScore || '-', ...meta],
        [scores?.sScore || '-', ...meta],
        [scores?.gScore || '-', ...meta],
        [
          {
            esgId: scopeId,
            totalScore: scores?.esgScore || '-',
          },
          ...meta,
        ],
        hasPermission,
        [scopeId, sentifiId],
      ];
    },
  );
